/* eslint-disable max-len */
export const HELPER_TEXT = {
  PENDING_DEBITS:
    'These funds are halted for the already performed operations. They are deducted from the available funds and may be refunded when the operation fails.',
  PENDING_CREDITS: 'These funds will become available after the transfers successful processing.',
  BALANCE:
    'These funds are available to cover operation fees. Once the funds reaches zero, only operations that do not require fees will be allowed. To add more funds to your wallet you can use "+" the in wallet card, or select "Add funds to your wallet" option in your user menu.'
};
